<template>
  <div>
    <v-select
      id="vSelectBotUser"
      v-model="selected_users"
      :multiple="multiple"
      :placeholder="placeholder"
      :options="all_users"
      :class="validator && selected_users.fullname ? '' : 'danger-select'"
      label="fullname"
      @search="userSearch"
    />
  </div>
</template>

<script>
import { debounce } from "lodash"
import VSelect from "vue-select"

export default {
  components: {
    VSelect,
  },
  props: {
    placeholder: {
      type: String,
      default: "Select the user to create the application for",
    },
    stateErrors: { type: Array, default: null },
    multiple: { type: Boolean, default: false },
    validator: { type: Boolean, default: false },
    clearSelect: { type: Boolean, default: false },
  },
  data() {
    return {
      all_users: [],
      selected_users: {},
    }
  },
  watch: {
    selected_users(val) {

      this.$emit("user-selected", val)
    },
    clearSelect(val) {
      if (val) {
        this.selected_users = this.multiple ? [] : {}
      }
    },
  },
  mounted() {
    this.selected_users = this.multiple ? [] : {}
  },

  methods: {
    userSearch(search, loading) {
      if (search.length > 0) {
        loading(true)
        this.searchForUser(loading, search, this)
      }
    },
    searchForUser: debounce((loading, search, vm) => {
      vm.getUsers(search, loading)
    }, 1000),

    getUsers(query, loading = null) {
      this.all_users = []
      this.$http
        .get(`/api/bot-applicant-search/${this.$route.name}/${query}`)
        .then((response) => {
          this.all_users = []
          const record = response.data

          if (record.success) {
            record.data.map((data) => {
              const item = {
                id: data.id,
                fullname: data.fullname,
                email_address: data.email_address,
              }
              this.all_users.push(item)
            })
          }
          if (loading) {
            loading(false)
          }
        })
        .catch((error) => {
          this.$handleErrorResponse(error)
        })
    },
  },
}
</script>
